import { useEffect, useState } from "react";
import QRCode from "qrcode";
import { CustomDialog } from "@/components/dialog/v1/CustomDialog";
import { copyShortUrl } from "../utils";

export function MdQrCode({ shortLink, onClose }) {
    const [dataUrl, setDataUrl] = useState(null);

    useEffect(() => {
        if (!shortLink) {
            setDataUrl(null);
            return;
        }

        // 인쇄물에도 쓸 수 있게 넉넉한 해상도로 만든다
        QRCode.toDataURL(shortLink.shortUrl, { width: 1024, margin: 2, errorCorrectionLevel: 'M' })
            .then(setDataUrl);
    }, [shortLink]);

    return (
        <CustomDialog open={!!shortLink} onClose={onClose}>
            <CustomDialog.CloseButton onClose={onClose} />
            {shortLink &&
                <div className="px-6 pb-6 flex flex-col items-center gap-4">
                    <h3 className="text-lg font-bold">QR 코드</h3>
                    <div className="w-[240px] h-[240px] rounded-xl border border-gray-200 p-2 flex items-center justify-center">
                        {dataUrl && <img src={dataUrl} alt={`${shortLink.shortUrl} QR 코드`} className="w-full h-full" />}
                    </div>
                    <p className="text-sm font-semibold break-all text-center">{shortLink.shortUrl}</p>
                    <p className="text-xs text-gray-500 text-center">QR 로 들어온 방문을 따로 보려면 <code>?src=qr</code> 를 붙인 링크로 만들어 쓰세요.</p>
                    <div className="w-full grid grid-cols-2 gap-2">
                        <button
                            type="button"
                            onClick={() => copyShortUrl(shortLink.shortUrl)}
                            className="rounded-lg border border-gray-300 py-2.5 text-sm font-semibold"
                        >
                            링크 복사
                        </button>
                        <a
                            href={dataUrl || undefined}
                            download={`shooluk-${shortLink.code}.png`}
                            className="rounded-lg bg-gray-900 hover:bg-gray-800 py-2.5 text-sm font-semibold text-white text-center"
                        >
                            PNG 다운로드
                        </a>
                    </div>
                </div>
            }
        </CustomDialog>
    );
}
